export const ROLE_ADMIN = 'Admin';
export const ROLE_USER = 'User';
export const ROLE_OWNER = 'Owner';

export const USER_ROLES = [
  { i18nKey: 'admin', value: ROLE_ADMIN },
  /*{ i18nKey: 'owner', value: ROLE_OWNER },*/
  { i18nKey: 'user', value: ROLE_USER },
];
